import createAlertsTourSlice, { type AlertsTourSliceState } from './alertsTour';
import createDriversTourSlice, { type DriversTourSliceState } from './driversTour';
import createMonitoringTourSlice, { type MonitoringTourSliceState } from './monitoringTour';
import createOnboardingStepsSlice, { type OnboardingStepsSliceState } from './onboardingSteps';
import createUserSettingsTourSlice, { type UserSettingsSliceState } from './userSettingsTour';
import createVehicleTourSlice, { type VehicleTourSliceState } from './vehicleTour';
import type { StateCreator } from 'zustand';

type OnboardingSlices = MonitoringTourSliceState & OnboardingStepsSliceState & UserSettingsSliceState & VehicleTourSliceState & AlertsTourSliceState & DriversTourSliceState;

const onboardingSlices: StateCreator<OnboardingSlices> = (setState, getState, store) => ({
  ...createOnboardingStepsSlice(setState, getState, store),
  ...createMonitoringTourSlice(setState, getState, store),
  ...createUserSettingsTourSlice(setState, getState, store),
  ...createVehicleTourSlice(setState, getState, store),
  ...createAlertsTourSlice(setState, getState, store),
  ...createDriversTourSlice(setState, getState, store),
});

export type { OnboardingSlices };
export default onboardingSlices;
